'use client';

import React__default from 'react';
import { Container } from './CirclePercent.css.js';

var CirclePercent = function (_a) {
    var _b = _a.percent, percent = _b === void 0 ? 30 : _b, _c = _a.width, width = _c === void 0 ? 36 : _c, _d = _a.color, color = _d === void 0 ? '#E6EFFF' : _d, _e = _a.strokeWidth, strokeWidth = _e === void 0 ? 1 : _e;
    return (React__default.createElement(Container, { width: width, strokeWidth: strokeWidth },
        React__default.createElement("svg", { viewBox: '0 0 36 36' },
            React__default.createElement("path", { width: width, height: width, style: { stroke: color }, className: 'circle', strokeDasharray: "".concat(percent, ", 100"), d: 'M18 2.0845\n          a 15.9155 15.9155 0 0 1 0 31.831\n          a 15.9155 15.9155 0 0 1 0 -31.831' }))));
};

export { CirclePercent as default };
//# sourceMappingURL=index.js.map
